import React from 'react';
import { useOffers } from '../hooks/useOffers';
import EventOffersSlider from './partials/Event-offerslider';
import EventCard from './EventCard';
import './Events.css';

const Offers = () => {
  const { offers, loading } = useOffers();

  return (
    <main className="bg_white">
      <EventOffersSlider />

      <div
        className="petti_cream_rep"
        style={{
          backgroundImage: "url('/assets/img/bg/offers-bg.webp')",
          backgroundSize: 'cover',
          backgroundPosition: 'center',
          backgroundRepeat: 'no-repeat',
          position: 'relative',
          backgroundColor: '#f5f5dc',
          minHeight: '60vh',
        }}
      >
        <div className="container margin_60_35" id="first_section">
          <div className="isotope-wrapper">
            <div className="title mb-3 text-center" style={{ paddingBottom: '20px' }}>
              <h2 data-cue="slideInUp" data-delay="200" style={{ color: '#18373b' }}>
                Offers at Petti Petti Mirissa
              </h2>
            </div>
            <div className="row justify-content-center home">
              {loading && (
                <div className="col-12 text-center">
                  <p className="event-status">Loading offers...</p>
                </div>
              )}

              {!loading && offers.length === 0 && (
                <div className="col-12 text-center">
                  <h3 className="event-status" style={{ fontSize: '30px', fontWeight: 700 }}>
                    No offers yet!
                  </h3>
                </div>
              )}

              {!loading && offers.map((offer) => (
                <div className="col-lg-4 col-md-6 col-12 mb-4" key={offer._id}>
                  <EventCard event={offer} />
                </div>
              ))}
            </div>
          </div>
        </div>
      </div>
    </main>
  );
};

export default Offers;
